import Vuex from 'vuex';
import tasks from './tasks';
import orderCustomersShow from './orderCustomersShow';
import categories from './categories';
import exports from './exports';
import suppliersCreate from './suppliersCreate';
import blacklist from './blacklist';
import baseForm from './baseForm';
import baseModal from './baseModal';
import table from './table';
import contextMenu from './contextMenu';
import centerUsageChart from './centerUsageChart';

const store = new Vuex.Store({
  modules: {
    tasks,
    orderCustomersShow,
    categories,
    exports,
    suppliersCreate,
    blacklist,
    baseForm,
    table,
    contextMenu,
    centerUsageChart,
    baseModal,
  },
  state: {
    newSidebarUsed: false,
    sidebarFixed: window.localStorage.getItem('_sf') !== 'false',
    showConfirmation: false,
  },
  mutations: {
    SET_NEW_SIDEBAR_USED(state, value) {
      state.newSidebarUsed = value;
    },
    TOGGLE_SIDEBAR_FIXED(state, value = null) {
      state.sidebarFixed = value === null ? !state.sidebarFixed : value;
      window.localStorage.setItem('_sf', state.sidebarFixed ? 'true' : 'false');
    },
    TOGGLE_CONFIRMATION(state) {
      state.showConfirmation = !state.showConfirmation;
    },
  },
});

export default store;
